import { useEffect, useState } from "react"

const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)"

function reducedMotionQuery(): MediaQueryList | null {
    if (
        typeof window === "undefined" ||
        typeof window.matchMedia !== "function"
    ) {
        return null
    }
    return window.matchMedia(REDUCED_MOTION_QUERY)
}

export function usePrefersReducedMotion(): boolean {
    const [isReducedMotionPreferred, setIsReducedMotionPreferred] =
        useState(false)

    useEffect(() => {
        const query = reducedMotionQuery()
        if (!query) return
        const update = () => setIsReducedMotionPreferred(query.matches)
        update()
        query.addEventListener("change", update)
        return () => query.removeEventListener("change", update)
    }, [])

    return isReducedMotionPreferred
}
